import React from "react";

/**
 * Renders a custom option label component.
 * @param {Object} props - The props object.
 * @param {string} props.label - The label to display.
 * @returns {JSX.Element} - The rendered custom option label component.
 */
const CustomeOptionLabel = ({ label }) => {
  return (
    <>
      <div className="selectWrapperDiv">
        <span>{label}</span>
      </div>
    </>
  );
};

export default CustomeOptionLabel;
